import React, { lazy, Suspense } from 'react'
import { clsx } from 'clsx'
import BodyText from '@ancon/wildcat-ui/web/orderweb/BodyText'
import HeadingText from '@ancon/wildcat-ui/web/orderweb/HeadingText'

import styles from './EmptyPlaceholder.module.scss'

const OrderCharacterConfused = lazy(
  () =>
    import(
      '@ancon/wildcat-ui/shared/illustrations/order-character-confused.svg'
    ),
)

type EmptyPlaceholderProps = {
  title: string
  message: string
  headerIcon?: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

export default function EmptyPlaceholder({
  title,
  message,
  headerIcon,
  footer,
  className,
}: EmptyPlaceholderProps) {
  return (
    <section className={clsx(styles.container, className)}>
      {headerIcon || (
        <Suspense>
          <OrderCharacterConfused />
        </Suspense>
      )}
      <HeadingText as="h2">{title}</HeadingText>
      <BodyText color="body-1">{message}</BodyText>

      {footer}
    </section>
  )
}
